/**
 * @class Oskari.arcgis.bundle.arcgis.MapArcGisBundle
 */
Oskari.clazz.define("Oskari.arcgis.bundle.arcgis.MapArcGisBundle", function () {}, {
  /*
   * implementation for protocol 'Oskari.bundle.Bundle'
   */
  "create": function create() {
    return null;
  },
  "update": function update(manager, bundle, bi, info) {
    manager.alert("RECEIVED update notification " + info);
  }
},
/**
 * metadata
 */
{
  "protocol": ["Oskari.bundle.Bundle", "Oskari.mapframework.bundle.extension.ExtensionBundle"],
  "source": {
    "scripts": [{
      "type": "text/javascript",
      "src": "../../../../bundles/mapping/maparcgis/plugin/ArcGisLayerPlugin.ol.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/mapping/maparcgis/domain/ArcGisLayer.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/mapping/maparcgis/domain/ArcGis93Layer.js"
    }]
  },
  "bundle": {
    "manifest": {
      "Bundle-Identifier": "maparcgis",
      "Bundle-Name": "maparcgis",
      "Bundle-Tag": {
        "mapframework": true
      },
      "Bundle-Icon": {
        "href": "icon.png"
      },
      "Bundle-Author": [{
        "Name": "jjk",
        "Organisation": "nls.fi",
        "Temporal": {
          "Start": "2009",
          "End": "2011"
        },
        "Copyleft": {
          "License": {
            "License-Name": "EUPL",
            "License-Online-Resource": "http://www.paikkatietoikkuna.fi/license"
          }
        }
      }],
      "Bundle-Name-Locale": {
        "fi": {
          "Name": "ArcGis",
          "Title": "ArcGis"
        },
        "en": {}
      },
      "Bundle-Version": "1.0.0",
      "Import-Namespace": ["Oskari"]
    }
  }
});
Oskari.bundle_manager.installBundleClass("maparcgis", "Oskari.arcgis.bundle.arcgis.MapArcGisBundle");
import '../../../../bundles/mapping/maparcgis/plugin/ArcGisLayerPlugin.ol.js'
import '../../../../bundles/mapping/maparcgis/domain/ArcGisLayer.js'
import '../../../../bundles/mapping/maparcgis/domain/ArcGis93Layer.js'